import Vue from 'vue';
import Router from 'vue-router';
import store from '../vuex'

import TicketCapture from '@/views/ticket/ticket-capture';
import TicketBill from '@/views/ticket/ticket-bill';
import TicketStore from '@/views/ticket/ticket-store';
import TicketDeliver from '@/views/ticket/ticket-deliver';
import TicketClient from '@/views/ticket/ticket-client';
import TicketCheck from '@/views/ticket/ticket-check';
import TicketEstimate from '@/views/ticket/ticket-estimate';
import TicketOffline from '@/views/ticket/ticket-offline';
import TicketCheckRollback from '@/views/ticket/ticket-check-rollback';
import TicketTransaction from '@/views/ticket/ticket-transaction';
import TicketCope from '@/views/ticket/ticket-cope';

import Account from '@/views/system/account';
import Menu from '@/views/system/menu';
import Role from '@/views/system/role';
import Department from '@/views/system/department';
import Warn from '@/views/system/warn';

import Index from '@/components/index';
import Login from '@/components/login';
import Auth from '@/components/auth';
import Error from '@/components/error';
import NoAuth from '@/components/noauth';
import Welcome from '@/components/welcome';

import Potential from '@/views/customer/potential';
import OwnerCustomer from '@/views/customer/owner';
import Echart from '@/views/customer/echart';

import TicketFlow from '@/views/ticket/ticket-flow';
import { TOKEN } from "@/utils";

Vue.use(Router);
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export const routes = [
    {
        
        path: '/ticket/flow',
        name: '流水',
        component: TicketFlow,
        meta: {
            requireAuth: true
        }
}
    ,

    {
        path: '/ticket/cope',
        name: '应付',
        component: TicketCope,
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/ticket/transaction',
        name: '应收',
        component: TicketTransaction,
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/ticket/check/rollback',
        name: '对账撤回',
        component: TicketCheckRollback,
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/ticket/capture',
        name: '抓票',
        component: TicketCapture,
        meta: {
            requireAuth: true
        }
    }, {
        path: '/ticket/store',
        name: '票据入库',
        component: TicketStore,
        meta: {
            requireAuth: true
        }
    }, {
        path: '/ticket/deliver',
        name: '票据出库',
        component: TicketDeliver,
        meta: {
            requireAuth: true
        }
    }, {
        path: '/ticket/client',
        name: '客户管理',
        component: TicketClient,
        meta: {
            requireAuth: true
        }
    }, {
        path: '/ticket/check',
        name: '对账',
        component: TicketCheck,
        meta: {
            requireAuth: true
        }
    }, {
        path: '/ticket/bill',
        name: '应收应付',
        component: TicketBill,
        meta: {
            requireAuth: true
        }
    }, {
        path: '/ticket/estimate',
        name: '拟售价管理',
        component: TicketEstimate,
        meta: {
            requireAuth: true
        }
    }, {
        path: '/ticket/offline',
        name: '线下入库',
        component: TicketOffline,
        meta: {
            requireAuth: true
        }
    }, {
        path: '/system/account',
        name: '账号管理',
        component: Account,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/system/menu',
        name: '菜单管理',
        component: Menu,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/system/role',
        name: '角色管理',
        component: Role,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/system/dept',
        name: '部门管理',
        component: Department,
        meta: {
            requireAuth: false
        }
    },
    {
        path: '/system/warn',
        name: '消息中心',
        component: Warn,
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/customer/manager',
        name: '客户管理',
        component: OwnerCustomer,
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/customer/potential',
        name: '未开发用户',
        component: Potential,
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/customer/echart',
        name: '客户图表',
        component: Echart,
        meta: {
            requireAuth: true
        }
    }

]

const router = new Router({
    routes: [
        {
            path: '/',
            name: '首页',
            component: Index,
            iconCls: 'el-icon-tickets',
            children: [
                {
                    path: 'noauth',
                    component: NoAuth
                },
                {
                    path: 'welcome',
                    component: Welcome
                },
            ]
        },
        {
            path: '/login',
            name: '登录',
            component: Login,
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/auth',
            component: Auth
        },
        {
            path: '/404',
            component: Error
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.meta.requireAuth) {
        if (Boolean(sessionStorage.getItem(TOKEN))) {
            if (store.getters.getUserInfo) {
                next()
            } else {
                const currPath = window.location.hash.replace('#', '')
                if (currPath.includes('/auth')) {
                    next()
                } else {
                    store.dispatch('getUserInfo', currPath.replace('#', '')).then(() => {
                    })
                }
            }
        } else {
            next('/login')
        }
    } else {
        if (Boolean(sessionStorage.getItem(TOKEN))) {
            if (store.getters.getUserInfo) {
                next()
            } else {
                const currPath = window.location.hash.replace('#', '')
                if (currPath.includes('/auth')) {
                    next()
                } else {
                    store.dispatch('getUserInfo', currPath.replace('#', '')).then(() => {
                    })
                }
            }
        } else {
            if (to.path === "/login" || to.path === '/auth') {
                next()
            } else {
                next('/login');
            }
        }
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js